import React from "react";
import MainLayout from "../layout/dashboard-container";
import { Grid, Tooltip } from "@mui/material";
// import Header from "../layout/header";
// import { Container } from "@mui/material";
const Home = () => {
  return (
    <MainLayout>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        style={{ height: "70vh" }} // Make sure the container takes full height
      >
        {/* <Typography variant="h5">WELCOME TO PCMC !!</Typography> */}
        <Tooltip title="पिंपरी चिंचवड महानगरपालिका">
          <img
            src="/pcmclogo.jpeg" // Replace with your image URL or import path
            alt="PCMC"
            style={{ maxWidth: "100%", height: "40vh" }}
          />
        </Tooltip>
      </Grid>
    </MainLayout>
  );
};

export default Home;
